import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { salesPrimaryBlockDefaultStyles } from "../constants";

export interface SalesBlock11Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
  footer: ReactNode;
  header: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const SalesBlock11 = forwardRef<HTMLDivElement, SalesBlock11Props>(
  ({ header, content, footer, className, styles, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: salesPrimaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background
          className="wb-bg-primary"
          style={backgroundStyles}
        >
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <div className="wb-mx-auto wb-flex wb-max-w-3xl wb-flex-col wb-gap-8 md:wb-gap-16">
                <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-flex-col wb-items-center wb-gap-4 wb-text-center md:wb-gap-6">
                  {header}
                </BlockSection.NestedBlock>
                <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-flex-col">
                  {content}
                </BlockSection.NestedBlock>
                <BlockSection.NestedBlock
                  block={footer}
                  render={footer => (
                    <div className="wb-mx-auto wb-flex wb-flex-col wb-justify-center wb-gap-10 md:wb-gap-16">
                      <div className="wb-flex wb-flex-col wb-items-center wb-gap-4 md:wb-gap-8 wb-justify-center">
                        {footer}
                      </div>
                    </div>
                  )}
                />
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

SalesBlock11.displayName = "SalesBlock11";
